import React from 'react';
import styles from './Instructions.module.css';
import newReservationScreenshot from '../../assets/images/new_reservation.png'
import addedScreenshot from '../../assets/images/added.png'
import viewReservationsScreenshot from '../../assets/images/view_reservations.png'
import paymentScreenshot from '../../assets/images/payment.png'
import statusScreenshot from '../../assets/images/status.png'
import periodicPay1Screenshot from '../../assets/images/periodicPay1.png'
import periodicPay2Screensho from '../../assets/images/periodicPay2.png'

const Instructions = () => {
    return (
        <div className={styles.instructionsContainer}>
            <h1>Jak zarezerwować kort </h1>
            <div className={styles.instructionText}>
                <h5>1. Rejestracja</h5>
                <p>Korzystanie z systemu rezerwacji wymaga założenia konta.
                    Kliknij w link "Rejestracja", wypełnij wymagane dane i postępuj zgodnie z instrukcjami.
                    Jeżeli w procesie rejestracji podałeś prawidłowy adres e-mail, w ciągu kilku sekund powinieneś
                    otrzymać wiadość z linkiem aktywacyjnym.
                    Należy w niego kliknąć aby dokończyć proces zakładania nowego konta. Nie odkładaj tej czynności bo link jest ważny 20
                    minut.</p>
            </div>
            <div className={styles.instructionText}>
                <h5>2. Dodanie nowej rezerwacji</h5>
                <div className={styles.imageContainer}>
                    <img src={newReservationScreenshot} alt="Rezerwacja" className={styles.floatingImageLeft}/>
                    <p>Po zalogowaniu się, przejedź na 'Rezerwacje'.
                        Obce rezerwacje są oznaczone kolorem czerwonym. Białe komórki to wolne terminy. Należy kliknać
                        w wybraną godzinę a na ekranie pojawi się projekcja
                        planowanej rezerwacji. Dla osób wynajmujących korty na godziny, dodatkowo będzie prezentowany koszt
                        wynajmu. W celu modyfikacji planowanego czasu gry, należy klikać lub odklikiwać odpowiednie komórki.
                        Jeżeli czas projekcji rezerwacji jest zgodny z Twoim oczekiwaniem  kliknij w przycisk 'Rezerwuj'.</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={addedScreenshot} alt="rezerwacja dodana" className={styles.floatingImageRight}/>
                    <p>Wprowadzona rezerwacja ze statusem REG, zostanie oznaczona kolorem zielonym (tym kolorem są oznaczone własne rezerwacje).</p>
                </div>
            </div>
            <div className={styles.instructionText}>
                <h5>3. Anulowanie rezerwacji </h5>
                <div className={styles.imageContainer}>
                    <img src={viewReservationsScreenshot} alt="przegląd rezerwacji" className={styles.floatingImageLeft}/>
                    <p>Własne rezerwacje można przeglądać bezpośrednio na grafiku (oznaczone są one kolorem zielonym) lub
                        w 'Moje Dane' w zakładce REZERWACJE, gdzie prezentowane są wszystkie zaplanowane i
                        archiwalne własne rezerwacje.
                        Do momentu rozpoczęcia zaplanowanej rezerwacji można ją anulowąć klikacjąc w znak 'X'. Własne
                        rezerwacje można też anulować bezpośrednio na grafiku, klikając w zielone komórki. Anulowana
                        rezerwacja oznaczona jest statusem ANL i znika z grafika. <br/><b>Uwaga!</b> Każda rezerwacja może być anulowana przez Administratora,
                    dlatego przed przyjściem na kort, należy sprawdzić czy moja rezerwacja jest nadal aktualna.</p>
                </div>
            </div>
            <div className={styles.instructionText}>
                <h5>4. Płatności </h5>
                <div className={styles.imageContainer}>
                    <img src={paymentScreenshot} alt="płatności" className={styles.floatingImageRight}/>
                    <p>W momencie, gdy przychodzi czas rezerwacji, pojawia się ona w 'Moje Dane' w zakładce
                        'PŁATNOŚCI'. Takiej rezerwacji nie da się już anulować.
                        Powstaje obowiązek zapłaty bez względu na to czy rezerwacja została wykorzystana czy nie. Przycisk
                        'Płacę' przenosi Cię do bramki płatności, gdzie za pomocą jednej z wielu metod (np. BLIK) można uregulować swoje należności.
                        W ciągu krótkiego czasu opłacona rezerwacja otrzymuje status OPL i
                        znika z listy nieopłaconych rezerwacji.</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={periodicPay1Screenshot} alt="płatność okresowa 1" className={styles.floatingImageLeft}/>
                    <p>W sytuacji gdy nie ma żadnych zaległych płatności pojawia się możliwość wniesienia opłaty okresowej,
                        która obniża koszty wynajmu kortów. Można się zdecydować na 7, 14 lub 30 dni ciągłego wynajmu kortu (2 godziny dziennie).</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={periodicPay2Screensho} alt="Platnosc okresowa 2" className={styles.floatingImageRight}/>
                    <p>Przycisk 'Płacę' rozpoczyna proces szybkiej płatności. Po jego zakończeniu, w zakładce 'PŁATNOŚCI'
                    jest widoczna data, do której można rezerwować korty w ramach opłaty okresowej.
                        Data ważności opłaty okresowej jest automatycznie przedłużana o każdy dzień niedostępności kortów.
                        Rezerwacja taka jest oznaczona statusem OKR.</p>
                </div>
                <div className={styles.imageContainer}>
                    <img src={statusScreenshot} alt="Rezerwacja" className={styles.floatingImageLeft}/>
                    <p>Statusy rezerwacji: <br/>
                        <b>REG</b> - rezerwacja zarejestrowana, <br/>
                        <b>OPL</b> - rezerwacja opłacona, <br/>
                        <b>OKR</b> - rezerwacja w ramach opłaty okresowej, <br/>
                        <b>ANL</b> - rezerwacja anulowana (brak obowiązku zapłaty), <br/>
                        <b>BTT</b> - rezerwacja w ramach składki członkowskiej.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Instructions;